import React from "react";
import moment from "moment";
import * as coverageJsonUtils from "@coverme/utils";

function getPrimaryAndSupplementalCoverages(coverages) {
    if (coverages == null || coverages.length === 0) {
        return {
            primaryCoverage: null,
            supplementalCoverage: [],
        };
    }

    coverages = coverages.filter(x => x.isPrimaryCoverage);

    let supplementalCoverageFromJson;

    if (coverages.length === 1) {
        supplementalCoverageFromJson = coverages[0].coverageJson
            ? getSupplementalFromJson(JSON.parse(coverages[0].coverageJson))
            : null;
        return {
            primaryCoverage: coverages[0],
            supplementalCoverage: supplementalCoverageFromJson ? [supplementalCoverageFromJson] : [],
        };
    }

    if (coverages.length >= 2) {
        const medicare = coverages.filter(x => x.healthInsuranceType?.name === "Medicare")[0];
        const nonMedicare = coverages.filter(x => x.healthInsuranceType?.name !== "Medicare");
        if (medicare != null) {
            return {
                primaryCoverage: medicare,
                supplementalCoverage: nonMedicare,
            };
        }

        return {
            primaryCoverage: nonMedicare[0],
            supplementalCoverage: nonMedicare.filter((x, i) => i !== 0),
        };
    }
}

const getSupplementalFromJson = json => {
    try {
        if (coverageJsonUtils.doesJsonHasSupplementalCoverage(json)) {
            const supplementalCoverage = coverageJsonUtils.getMedicareAttributesFromJson(json).supplementalDetails;
            return {
                companyName: supplementalCoverage.name,
                plan: supplementalCoverage.planNetworkName,
                effectiveDate: supplementalCoverage.benefitBeginDate,
            };
        }
    } catch {
        return null;
    }
};

export function MiniFacesheetCoverage({ coverages, ...props }) {
    const coverageBreakdown = getPrimaryAndSupplementalCoverages(coverages);
    return (
        <div className="mini-facesheet__coverages">
            <CoverageItem coverage={coverageBreakdown.primaryCoverage} title="Primary Coverage" />
            {coverageBreakdown.supplementalCoverage.map((x, i) => {
                return <CoverageItem coverage={x} title="Supplemental Coverage" key={`coverage_item_${i}`} />;
            })}
        </div>
    );
}

function CoverageItem({ title, coverage }) {
    return (
        <div className="coverage-item">
            <h4>{title}</h4>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Name </span>
                    {coverage.companyName}
                </span>
            </div>

            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Plan/ Group </span>
                    {coverage.plan}
                </span>
            </div>
            {coverage.memberId && (
                <div className="mini-facesheet__info-item">
                    <span className="p-regular">
                        <span className="h5">Member Id </span>
                        {coverage.memberId}
                    </span>
                </div>
            )}
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Effective Date </span>
                    {moment(coverage.effectiveDate).format("MM-DD-YYYY")}
                </span>
            </div>
        </div>
    );
}
